import Vue from 'vue';
import Router from 'vue-router';

/*
* 加此段代码为解决院校列表页面重复点击search按钮时路由报错
* */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const talentSearch = () => import('@/page/talent/search');//引才列表
const collegeSearch = () => import('@/page/college/search');//院校列表
const collegeDetail = () => import('@/page/college/detail');//院校详情
const collegeNewDetail = () => import('@/page/college/detail_new');//院校详情（权重大于50转入新详情页）
const collegeOrgan = () => import('@/page/college/organ');//院校在招职位
const collegeActivity = () => import('@/page/college/activity');//院校引才活动
const employSearch = ()=> import('@/page/employ/search'); // 招聘
const employDetail = ()=> import('@/page/employ/detail'); // 招聘详情
const employVipDetail = ()=> import('@/page/employ/VipDetail'); // 权重较高职位详情
const activitySearch = ()=> import('@/page/activity/search'); // 引才活动
const activityDetail = ()=> import('@/page/activity/detail'); // 引才活动详情

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/public/talent",
  routes: [
    {path: '*',redirect: '/search'},
    {path: '',redirect: '/search'},
    {path: '/',redirect: '/search'},
    {
        path: '/search',
        name: 'talentSearch',
        component: talentSearch,
    },

    {path: '/college', redirect: '/college/search'},
    {path: '/college/', redirect: '/college/search'},
    {
        path: '/college/search',
        name: 'collegeSearch',
        component: collegeSearch,
    },

    /*{path: '/college/detail', name: 'collegeDetailOld', component: collegeDetail},*/
    {path: '/college/detail/:id', name: 'collegeDetail', component: collegeDetail},

    /*{path: '/college/ndetail', name: 'collegeNewDetailOld', component: collegeNewDetail},*/
    {path: '/college/ndetail/:id', name: 'collegeNewDetail', component: collegeNewDetail},

    {path: '/college/organ/:id', name: 'collegeOrgan', component: collegeOrgan},

    {path: '/college/activity/:id', name: 'collegeActivity', component: collegeActivity},

    {path: '/employ', redirect: '/employ/search'},
    {path: '/employ/', redirect: '/employ/search'},
    {
        path: '/employ/search',
        name: 'employSearch',
        component: employSearch,
    },

    {path: '/employ/detail/:id', name: 'employDetail', component: employDetail},
    {path: '/employ/vipDetail/:id', name: 'employVipDetail', component: employVipDetail},

    {path: '/activity', redirect: '/activity/search'},
    {path: '/activity/', redirect: '/activity/search'},
    {
        path: '/activity/search',
        name: 'activitySearch',
        component: activitySearch,
    },

    {path: '/activity/detail', name: 'activityDetailOld', component: activityDetail},//兼容旧版
    {path: '/activity/:id', name: 'activityDetail', component: activityDetail}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js